
require.register("babel-runtime/node_modules/core-js/library/modules/_to-iobject.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "babel-runtime/node_modules/core-js");
  (function() {
    // to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};
  })();
});